export default __webpack_public_path__ + "static/media/home_explain_export_import@2x.65bb1837.png";